import React from 'react';
import { hoursLabel } from './shiftStatuses';

export const TeamRosterSummary = ({ members }) => {
  const active = members.filter(m => m.active);
  const days = active.flatMap(m => m.days);
  const cells = [
    ['active', 'Active members', active.length],
    ['hours', 'Scheduled hours', hoursLabel(days.reduce((sum, d) => sum + (d.working_minutes || 0), 0))],
    ['away', 'Off / leave days', days.filter(d => !['working', 'unset'].includes(d.state)).length],
    ['conflicts', 'Days with conflicts', days.filter(d => d.busy.some(e => e.conflicts.length)).length],
  ];
  return <div data-testid="team-roster-summary" className="grid grid-cols-2 md:grid-cols-4 gap-5 border-b pb-5">{cells.map(([id, label, value]) => <div key={id}><p className="text-xs text-slate-500">{label}</p><p data-testid={`team-summary-${id}`} className={`text-2xl font-semibold mt-1 ${id === 'conflicts' && value ? 'text-red-700' : 'text-slate-800'}`}>{value}</p></div>)}</div>;
};